import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";

export default class HarleyFreespinRecord extends FreespinRecord {
    
    public retrigger: boolean = false;

    public giftedAdditional: number = 0;
    
}